"use strict";

exports.__esModule = true;
exports.default = void 0;
var _baseGetAllKeys = _interopRequireDefault(require("./_baseGetAllKeys.js"));
var _getSymbols = _interopRequireDefault(require("./_getSymbols.js"));
var _keys = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return (0, _baseGetAllKeys.default)(object, _keys.default, _getSymbols.default);
}
var _default = exports.default = getAllKeys;